module.exports = __webpack_public_path__ + "img/person_icon.7d91912d.png";